<template>
  <page :title="title" :breadcrumb="breadcrumb" :load="doInit">
    <!-- <template slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <v-btn text color="secondary" v-on="on">
            More Links...
            <v-icon right>mdi-link</v-icon>
          </v-btn>
          <side-function-menu :items="sideFunction" @doClick="sideMenuClick"></side-function-menu>
        </v-menu>
      </div>
    </template> -->
    <v-card>
      <!-- <v-card-title>
        <span class="title">{{ newScheme ? 'New Scheme' : 'Scheme Review' }}</span>
      </v-card-title> -->
      <transition name="slide-x-transition" mode="out-in">
        <router-view :routerKey="routerKey"></router-view>
      </transition>
    </v-card>
  </page>
</template>

<script>
// import SideFunctionMenu from '@/components/parameters/package/scheme/SideFunctionMenu'
import { mapGetters } from 'vuex'
import routeMixin from '@/mixins/route'

export default {
  data() {
    return {
      breadcrumb: [],
      sideFunction: [{ text: 'General', icon: 'mdi-account', iconColor: 'primary', params: { key: 'schemeReview' } }],
      routerKey: undefined,
      newScheme: false
    }
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName']),
    title() {
      if (this.newScheme) {
        return 'New Scheme'
      } else if (this.query) {
        return 'Query Scheme'
      } else {
        return 'Review Scheme'
      }
    },
    intermediary() {
      return this.$store.state.adminInter.intermediary
    }
  },
  methods: {
    async doInit() {
      if (this.scheme === 'new') {
        this.newScheme = true
        this.routerKey = 'schemeReview'
      } else if (this.query) {
        this.routerKey = 'schemeReview'
      } else {
        this.routerKey = 'schemeReview'
        this.sideFunction.push({
          text: 'Scheme & Policy Type',
          icon: 'mdi-folder-account',
          iconColor: 'primary',
          params: { key: 'schemeReviewPolTypeScheme', params: { scheme: this.scheme } }
        })
      }
      this.breadcrumb = this.derieveBreadcrumbByName('scheme')
      this.breadcrumb.push({
        name: 'schemeReview',
        text: this.title
      })
    },
    sideMenuClick(data) {
      this.$router.push({ name: data.key, params: data.params })
    }
  },
  props: ['scheme', 'query'],
  // components: {
  //   SideFunctionMenu
  // },
  mixins: [routeMixin]
}
</script>

<style lang="scss">
.queryPnl {
  margin-top: 50px;
}
.smallMenu {
  width: 400px !important;
}
</style>
